import React, { useState, useEffect } from "react";
import { Col, Row, Image, Card, Button, Modal } from "antd";
import "antd/dist/reset.css";
import "../containers/customLayout.css";
import '../App.css';
import userGuideService from "../services/userGuideService";
import util from "../utils/functions/custom";
import {openNotification, ParagraphHeader, pdfjsVersion} from "@seims/shared";
import { recordError } from '../utils/logService';
import { Messages, Notify } from "../services/custom/Messages";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout"; 

import { Viewer, Worker } from "@react-pdf-viewer/core";

const UserGuideView = () => {
  const initWidth = 650;
  const emptyString = "";
  const [userGuides, setUserGuides] = useState([{}]);
  const [physicalFile, setPhysicalFile] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [progressMessage, setProgressMessage] = useState("File is being uploaded, please wait...");
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(emptyString);
  const [previewTitle, setPreviewTitle] = useState(emptyString);
  const [toggleFiles, setToggleFiles] = useState(false);
  const [modalWidth, setModalWidth] = useState(initWidth);


  useEffect(() => {
    loadUserGuides();
  }, [])

  const loadUserGuides = async () => {
    let msg;

    try {
      const response = await userGuideService.getUserGuides("all-public");
      if (response && response.status == 200) {
        const { data } = response;
        setUserGuides(data);
      };
    } catch (error) {
      msg = util.parseMessage(Messages.UPDATE_FAILURE, "Load User Guides");
      openNotification("Load User Guides", msg, Notify.ERROR);
      recordError(error);
    }
  };

  const handlePreviewDocument = async (id, document) => {
    try {
      setProgressMessage("File is being downloaded, please wait...")
      setSubmitted(true);
      const response = await userGuideService.downloadFile(id);
      if (response) {
        setSubmitted(false);
        const { data } = response;
        const new_blob = new Blob([data]);
        const url = URL.createObjectURL(new_blob);

        setPreviewImage(url);
        setPreviewOpen(true);
        setPreviewTitle(document.filename);
        setToggleFiles(document.type !== "application/pdf");
      }

    } catch (error) {
      recordError(error);
    }
  };
  const handleCancel = () => setPreviewOpen(false);

  const handleDownloadDocument = async (id, filename) => {
    let msg;
    try {
      setProgressMessage("File is being downloaded, please wait...")
      setSubmitted(true);
      const response = await userGuideService.downloadFile(id);
     
      if (response) {
        setSubmitted(false);
        const { data } = response;
        const new_blob = new Blob([data]);

        const url = URL.createObjectURL(new_blob);
        const downloadLink = document.createElement("a");

        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
        URL.revokeObjectURL(url);

      }
    } catch (error) {
      msg = util.parseMessage(Messages.FILEDOWNLOAD_FAILURE, "File");
      openNotification("File Download", msg, Notify.ERROR);
      console.log("PHYSICAL FILE", error);
      recordError(error);
    }
  };

  return (
    <>
      <Row justify="center" className="page-header" style={{ marginBottom: 10 }}>
        <Col xs={12} md={6} lg={4}>
          <div>
            <Image
              style={{ textAlign: 'center' }}
              preview={false}
              src={require("../assets/userGuide.png")}
              alt="User Guides"
            />
          </div>
        </Col>
      </Row>
      <Row justify="center" style={{ paddingBottom: 30 }} className="public-portal-page user-guides-page">
        <Col lg={18} xs={24} style={{ height: '100%'}}>
          <ParagraphHeader header="User Guides" />
          <Row gutter={[16, 16]} className="card-section">
            {userGuides.map((item, index) => (
              <Col key={index} xs={24} sm={12} md={8} lg={6}>
                <Card className="guide-card">
                  <h3 className="guide-title">{item.filename}</h3>
                  <br></br>
                  <Row className="guide-buttons">
                    <Col> <Button
                      type="primary"
                      shape="round"
                      onClick={() => handlePreviewDocument(item.uuid, item)}
                    >
                      View
                    </Button>
                    </Col>
                    <Col> <Button
                      style={{ marginLeft: 15 }}
                      type="primary"
                      shape="round"
                      onClick={() => handleDownloadDocument(item.uuid, item?.filename)}
                    >
                      Download
                    </Button>
                    </Col>
                  </Row>

                </Card>
              </Col>
            ))}       
          </Row>
        </Col>
      </Row>

      <Modal
        key={"modal-preview"}
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={modalWidth}
      >
        <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion()}/build/pdf.worker.min.js`}
        >
          <Viewer
            fileUrl={previewImage}
            plugins={[defaultLayoutPluginInstance]}
            renderError={console.log}
          />
        </Worker>

      </Modal>
    </>


  );
}

export default UserGuideView;